import { AppState } from './app';
import * as constants from '../constants';
import { addToSSObject } from '../utils/react';

// We type the payload cast inside each switch case:
export type ResultFiltersActionType = {
  type:
    | typeof constants.SET_RESULTS_FILTERS_VISIBILITY
    | typeof constants.SEARCH_RESULT
    | typeof constants.UPDATE_DATE_ACCURACY
    | typeof constants.SET_RESULTS_FILTERS
    | typeof constants.UPDATE_DURATION
    | typeof constants.UPDATE_DIGITAL
    | typeof constants.UPDATE_BUDGET
    | typeof constants.UPDATE_START_DATE
    | typeof constants.UPDATE_ATTRIBUTES1
    | typeof constants.UPDATE_ATTRIBUTES2
    | typeof constants.RESET_ATTRIBUTES2
    | typeof constants.SET_FILTERS;

  payload: any;
};

export const resultFilterReducer = (state: AppState, action: ResultFiltersActionType) => {
  switch (action.type) {
    case constants.SET_RESULTS_FILTERS_VISIBILITY: {
      return {
        ...state,
        filterVisibility: action.payload,
      };
    }

    case constants.SEARCH_RESULT: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          searchResults: action.payload.data,
        },
      };
    }

    case constants.UPDATE_DATE_ACCURACY: {
      addToSSObject('userDataEC', 'dateAccuracy', action.payload);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          dateAccuracy: action.payload,
          shouldCreateNewBasketJ1: true,
        },
      };
    }

    case constants.SET_RESULTS_FILTERS: {
      if (action.payload.format) {
        addToSSObject('userDataEC', 'format', action.payload.format);
      } else if (action.payload.target) {
        addToSSObject('userDataEC', 'target', action.payload.target);
      } else if (action.payload.attribute) {
        addToSSObject('userDataEC', 'attribute', action.payload.attribute);
      }

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          ...action.payload,
        },
      };
    }

    case constants.UPDATE_DURATION: {
      addToSSObject('userDataEC', 'duration', action.payload);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          duration: action.payload,
        },
      };
    }

    case constants.UPDATE_DIGITAL: {
      addToSSObject('userDataEC', 'digital', action.payload);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          digital: action.payload,
          shouldCreateNewBasketJ1: true,
        },
      };
    }

    case constants.UPDATE_BUDGET: {
      addToSSObject('userDataEC', 'budget', action.payload);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          budget: action.payload,
          shouldCreateNewBasketJ1: true,
        },
      };
    }

    case constants.UPDATE_START_DATE: {
      const codeName = '1002_App\\Shop\\Domain\\Exception\\BasketValidationException';
      const newErrors = { ...state.errors };
      newErrors[codeName] && delete newErrors[codeName];

      addToSSObject('userDataEC', 'startDate', action.payload[0]);
      return {
        ...state,
        errors: { ...newErrors },
        userDataEC: {
          ...state.userDataEC,
          startDate: action.payload[0],
          duration: action.payload[1] || 7,
          shouldCreateNewBasketJ2: true,
          shouldCreateNewBasketJ1: true,
        },
      };
    }

    case constants.UPDATE_ATTRIBUTES1: {
      let availableAttributesJ1 = { ...state.availableAttributesJ1 };
      availableAttributesJ1[action.payload.objName][action.payload.attr] = action.payload.val;

      return {
        ...state,
        availableAttributesJ1: { ...availableAttributesJ1 },
      };
    }

    case constants.UPDATE_ATTRIBUTES2: {
      let availableAttributesJ2 = { ...state.availableAttributesJ2 };
      availableAttributesJ2[action.payload.objName][action.payload.attr] = action.payload.val;

      return {
        ...state,
        availableAttributesJ2: { ...availableAttributesJ2 },
      };
    }

    case constants.RESET_ATTRIBUTES2: {
      return { ...state, availableAttributesJ2: action.payload };
    }

    case constants.SET_FILTERS: {
      return {
        ...state,
        filters: action.payload,
      };
    }
  }
};
